import React from 'react'

import Experiment from '@mc/experiments-react'

import { CustomerSupportChatbot } from './CustomerSupportChatbot'

const CUSTOMER_SUPPORT_CHATBOT_EXPERIMENT_KEY = 'pen-4213_v4'

export const CustomerSupportChatbotExperimentWrapper = ({
  pageSource,
  courseSlug,
  categorySlug,
  subcategorySlug,
}: {
  pageSource: string
  courseSlug?: string
  categorySlug?: string
  subcategorySlug?: string
}) => (
  <Experiment
    name={CUSTOMER_SUPPORT_CHATBOT_EXPERIMENT_KEY}
    variant_1={CustomerSupportChatbot}
    pageSource={pageSource}
    courseSlug={courseSlug}
    categorySlug={categorySlug}
    subcategorySlug={subcategorySlug}
  />
)
